<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="onSubmit()"
>
  <div class="report-on-road-operation">
    <form [formGroup]="pickupManifestForm" class="form-wrapper">
      <app-from-to-date
            [fromControl]="'fromDate'"
            [toControl]="'toDate'"
            [formGroupValue]="pickupManifestForm"
          ></app-from-to-date>
    <ion-row>
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
          <app-form-select
            [label]="CONSTS.ROUTE"
            [options]="routes"
            [customClass]="'scan-type-dropdown report-select'"
            formControlName="route"
          >
          </app-form-select>
        </ion-col>
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
          <app-report-format
            [radioButtonValue]="pickupManifestForm.get('reportFormat')?.value"
            (emitRadioChange)="radioChange($event)"
          ></app-report-format>
        </ion-col>
      </ion-row>
    </form>
    <app-download-note [numRows]="'2,000'"> </app-download-note>
  </div>
</app-modal-frame>

<!-- JSPDF DOES NOT SUPPORT NEWER STYLING LIKE FLEX AND VW, 
 SO FORCED TO USE OLD AND BASIC HTML STYLING -->
<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [hasSingleSubHeaderView]="false"
  [isNonTableView]="true"
>
  @if (pickupManifestReport && pickupManifestReport.response) {
    <!-- HEADER LABELS -->
    <ng-container sub-header>
      <table aria-hidden="true" class="pm-header-table">
        <tr class="pm-header-row">
          <td>
            {{ PDF_REPORT.HEADER.LOCATION }}
            {{ pickupManifestReport.response.location }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.LOOP }}
            {{ reportLoop }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.USER }}
            {{ driverUserID }}
          </td>
          <td>
            {{ pickupManifestForm.get("fromDate")?.value | date: "yyyy-MM-dd" }}
            to
            {{ pickupManifestForm.get("toDate")?.value | date: "yyyy-MM-dd" }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  @if (pickupManifestReport && pickupManifestReport.response) {
    <!------------------------>
    <ng-container custom-report>
      <!-- CUSTOM TABLE HEADER -->
      <table
        aria-hidden="true"
        class="pm-custom-header-table"
      >
        @for (row of PDF_REPORT.COLUMNS; track row) {
          <tr class="pm-custom-header-row">
            @for (column of row; track column) {
              <td class="pm-custom-header-cell">
                <div class="pm-custom-header-content">
                  {{ column }}
                </div>
              </td>
            }
          </tr>
        }
      </table>
      <!------------------------>
      <!-- CUSTOM TABLE BODY -->
      @for (stopItem of pickupManifestGroup; track stopItem) {
        <table
          aria-hidden="true"
          class="pm-body-table"
        >
          @for (columnData of stopItem.pickupManifests; track columnData) {
            @for (row of PDF_REPORT.DATA_ROWS; track row; let j = $index) {
              <tr class="pm-body-row">
                @for (field of row; track field) {
                  <td
                    class="pm-body-cell"
                    [class.pm-body-cell-extra-padding]="j === 1"
                  >
                    @if (field === "stop") {
                      @if (isAllOptionSelected) {
                        {{ columnData.loop }}
                      } @else {
                        {{ columnData.stop }}
                      }
                    } @else {
                      {{ columnData[field] || " " }}
                    }
                  </td>
                }
              </tr>
            }
          }
        </table>
      }
      <!------------------------>
      <!-- SUMMARY SECTION -->
      <table
        aria-hidden="true"
        class="pm-summary-table"
      >
        <tr class="pm-summary-title-row">
          <td class="pm-summary-cell">
            {{ PDF_REPORT.FOOTER.SUMMARY }}
          </td>
          <td class="pm-summary-cell">
            {{ PDF_REPORT.FOOTER.LOCATION }}
            {{ pickupManifestReport.response.location }}
          </td>
          <td class="pm-summary-cell">
            {{ PDF_REPORT.FOOTER.LOOP }}
            {{ pickupManifestReport.response.loop }}
          </td>
        </tr>
        <tr class="pm-summary-data-row">
          <td class="pm-summary-cell">
            {{ PDF_REPORT.FOOTER.PICKUP_STOPS }}
            {{ pickupManifestReport.response.pickupStops }}
          </td>
          <td class="pm-summary-cell">
            {{ PDF_REPORT.FOOTER.PICKUP_PACKAGES }}
            {{ pickupManifestReport.response.pickupPackages }}
          </td>
          <td class="pm-summary-cell">
            {{ PDF_REPORT.FOOTER.TOTAL_COLLECTED }}
            {{ pickupManifestReport.response.totalCollected }}
          </td>
        </tr>
      </table>
      <!--------------------->
    </ng-container>
  }
</app-pdf-report-generator>
